import React from "react";

export const References = () => {
  return (
<div>
      <div style={{ textAlign: "left", paddingLeft: "150px", marginTop: "-140px" }}>
        <h5>References</h5>
        <ul style={{ fontSize: "30px", paddingLeft: "70px", marginTop: "10px", maxWidth: "1200px" }}>
          <li style={{ wordWrap: "break-word", marginBottom: '25px'}}>
            [1] Alex Chamberlain. A Visualized Primer on Vertical Approach Angle (VAA). February 2022.
          </li>
          <li style={{ wordWrap: "break-word", marginBottom: '25px'}}>
            [2] Chris Langin. Pitch Design: What Is Stuff+? Quantifying Pitches with Pitch Models. May 2022.
          </li>
          <li style={{ wordWrap: "break-word", marginBottom: '25px'}}>
            [3] Nick Pollack. What Is PLV? – An Introduction To Pitch Level Value And Its Applications. February 2023.
          </li>
          <li style={{ wordWrap: "break-word", marginBottom: '25px'}}>
            [4] Jake Sauberman. Quantifying Pitcher Deception. December 2020.
          </li>
          <li style={{ wordWrap: "break-word", marginBottom: '25px'}}>
            [5] Philippa Swartz, Mike Grosskopf, Derek Bingham, and Tim Swartz. The Quality of Pitches in Major League Baseball. June 2016.
          </li>
          <li style={{ wordWrap: "break-word", marginBottom: '25px'}}>
            [6] Jason Wilson. Measuring the Quality of a Pitch. March 2017.
          </li>
        </ul>
      </div>
    </div>
  );
};
